// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationDot: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 10,
    color1 = "#577538",
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 10 10" width={size} height={size}>
        <path fill="currentColor" d="M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0m0 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8" />
    </svg>
);

export default React.memo(PaginationDot);
